import { render, staticRenderFns } from "./LeadRegistrationSuccess.vue?vue&type=template&id=422f6413&"
import script from "./LeadRegistrationSuccess.vue?vue&type=script&lang=js&"
export * from "./LeadRegistrationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports